import React, { ReactElement } from "react";
import { Route } from "react-router-dom";
import { DetailsPageRoute } from "../pages/details";

const routes: ReactElement<typeof Route>[] = [DetailsPageRoute];

export default routes;
